import { Form, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { User } from '@/models/user';
import Modal from '@/components/Modal';

const formLayout = { labelCol: { span: 5 }, labelAlign: 'right' as 'right' };

type PublishModalProps = {
  edit: User;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: User) => void;
};
const UserEditModal: React.FC<PublishModalProps> = ({
  edit,
  loading,
  onCancel,
  onSubmit,
}: PublishModalProps) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(!!edit);

  useEffect(() => {
    setOpen(Boolean(edit));
  }, [edit]);

  if (!edit) return null;

  return (
    <Modal
      title={edit.id ? '客户信息完善' : '手工录入客户信息'}
      open={open}
      destroyOnHidden
      confirmLoading={loading}
      onOk={() => {
        form.submit();
      }}
      afterClose={onCancel}
      onCancel={() => {
        setOpen(false);
      }}>
      <Form form={form} initialValues={edit} onFinish={onSubmit}>
        <Form.Item colon name="remarkName" label="备注名" {...formLayout} rules={[{ max: 20 }]}>
          <Input />
        </Form.Item>
        <Form.Item colon name="mobile" label="手机号" {...formLayout}>
          <Input type={'number'} pattern="\d*" />
        </Form.Item>
        <Form.Item name="memo" label="备注信息" {...formLayout}>
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserEditModal;
